// import one from '../assets/svg/projects/one.svg'
// import two from '../assets/svg/projects/two.svg'
// import three from '../assets/svg/projects/three.svg'
// import four from '../assets/svg/projects/four.svg'
// import five from '../assets/svg/projects/five.svg'
// import six from '../assets/svg/projects/six.svg'
// import seven from '../assets/svg/projects/seven.svg'
// import eight from '../assets/svg/projects/eight.svg'
import incontrol from '../assets/projects/Incontrol/incontrol-1.png'
import range from '../assets/projects/DigitalRange/range-1.png'
import instacap from '../assets/projects/instacap.png'
import memory from '../assets/projects/memory.png'
import hakkei from '../assets/projects/hakkei.png'


export const projectsData = [
    {
        id: 1,
        projectName: 'Memory Gardens',
        projectDesc: 'This project aims to build an employee management system that consolidates all information of a company',
        tags: ['React', 'Nodejs', 'Chakra UI', 'Stripe', 'Bitpay'],
        code: 'https://memorygardens.xyz/',
        demo: 'https://memorygardens.xyz/',
        image: memory
    },
    {
        id: 2,
        projectName: 'Instacap',
        projectDesc: 'Annotate screenshots without opening multiple apps and photo editors.  Share a cropped or full scrolling webpage screen capture with annotations and comments in one click.',
        tags: ['React Typescript', 'Tailwind CSS','Firebase'],
        code: 'https://app.instacap.co/',
        demo: 'https://app.instacap.co/',
        image: instacap
    },
    {
        id: 3,
        projectName: 'Incontrol',
        projectDesc: 'An inventory control system that manages, control and group differant inventories.',
        tags: ['ReactJS','Redux', 'CSS', 'Bootstrap'],
        code: 'https://incontrol.rocks',
        demo: 'https://incontrol.rocks',
        image: incontrol
    },
    {
        id: 4,
        projectName: 'Digital Range',
        projectDesc: 'The leader for country club and golf course digital marketing technology. Get access to user-friendly tools to help manage your digital presence and generate new leads.',
        tags: ['ReactJS', 'NodeJS','AWS RDS', 'AWS Cognito'],
        code: 'https://github.com/hhhrrrttt222111/developer-portfolio',
        demo: 'https://github.com/hhhrrrttt222111/developer-portfolio',
        image: range
    },
    {
        id: 5,
        projectName: 'Hakkei',
        projectDesc: 'The HX-S Series has been designed to make advanced functions that simplify repetitive tasks more accessible for everyone.',
        tags: ['Gatsby JS', 'Tailwind CSS'],
        code: 'https://www.hakkei.co/',
        demo: 'https://www.hakkei.co/',
        image: hakkei
    },
    // {
    //     id: 6,
    //     projectName: 'Uber Lite',
    //     projectDesc: 'Uber clone',
    //     tags: ['Flutter'],
    //     code: 'https://github.com/hhhrrrttt222111/developer-portfolio',
    //     demo: 'https://github.com/hhhrrrttt222111/developer-portfolio',
    //     image: six
    // },
    // {
    //     id: 7,
    //     projectName: 'Stock Market App',
    //     projectDesc: 'A simple stock market API app',
    //     tags: ['React', 'Redux', 'Bootstrap'],
    //     code: 'https://github.com/hhhrrrttt222111/developer-portfolio',
    //     demo: 'https://github.com/hhhrrrttt222111/developer-portfolio',
    //     image: seven
    // },
    // {
    //     id: 8,
    //     projectName: 'Car Pooling System',
    //     projectDesc: 'The carpooling system merges multiple people in a car which leads to meet new people, reduces pollution',
    //     tags: ['Flutter', 'React'],
    //     code: 'https://github.com/hhhrrrttt222111/developer-portfolio',
    //     demo: 'https://github.com/hhhrrrttt222111/developer-portfolio',
    //     image: eight
    // },
]


// Do not remove any fields.
// Leave it blank instead as shown below

/* 
{
    id: 1,
    projectName: 'Car Pooling System',
    projectDesc: '',
    tags: ['Flutter', 'React'],
    code: '',
    demo: '',
    image: ''
}, 
*/